import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { evidenceIcon, evidenceTooltip } from "./evidenceTypes.js";

function MechanismEvidence({ table, row }) {
  // Only show an evidence glyph when there actually is a mechanism. The call
  // sites already gate on mechanism_id; guarding here too means a stray render
  // can never show a "?" for a row that has no mechanism at all.
  if (!table[row].mechanism_id) {
    return <span style={{ position: "relative" }} />;
  }

  const evidence = table[row].mechanism_evidence;
  return (
    <span style={{ position: "relative" }}>
      <FontAwesomeIcon
        icon={evidenceIcon(evidence)}
        color="rgb(0,0,0,0.8)"
        id="seeEvizens"
      />
      <div id="terezaEvizens">{evidenceTooltip(evidence)}</div>{" "}
    </span>
  );
}

export default MechanismEvidence;
